import ClientNotificationInterface from '../../interfaces/client/Notification'

import generateUniqueId from '../generateUniqueId'

/**
 * Please note that this method is called a 'custom' notification
 * due to the name clash with the current build notification method.
 * Once that can be removed this should be renamed to 'buildNotification'.
 */
export default (
  notification: ClientNotificationInterface
): ClientNotificationInterface => {
  const notificationId =
    notification.id !== undefined ? notification.id : generateUniqueId()

  return {
    ...notification,
    id: notificationId,
  }
}
